import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { Button, MenuItem, TextField } from "@mui/material";
import { useStore } from "../hooks/store";
import { getTheme } from "../utils/API/themeMethods";
import {
  getPddById,
  getPddTheme,
  postPdd,
  updatePdd,
} from "../utils/API/pddMethods";

import { useNavigate, useSearchParams } from "react-router";
import { Editor } from "@tinymce/tinymce-react";
import FolderTree from "./folderTree/FolderTree";

export default function CustomMDEditor() {
  const [docValue, setDocValue] = React.useState({ text: "", theme_id: "" });
  const [docError, setDocError] = React.useState({
    text: false,
    theme_id: false,
  });

  const [themeList, setThemeList] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const store = useStore();
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    async function getPageData() {
      const themes = await getPddTheme();
      if (themes.status === 200) {
        setThemeList(themes.data);
        const pdd_id = params.get("id");
        if (pdd_id) {
          const pddData = pdd_id && (await getPddById(pdd_id));
          setDocValue({
            text: pddData.data[0].text,
            theme_id: pddData.data[0].theme_id,
          });
        }

        setLoading(false);
      }
    }

    getPageData();
  }, []);

  const handleChange = (value, name) => {
    const currentValue = value;
    const filedName = name;
    const newValues = { ...docValue };

    newValues[filedName] = currentValue;

    setDocValue(newValues);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    const pdd_id = params.get("id");

    if (docValue.theme_id === "") {
      setDocError({ ...docError, theme_id: "Укажите тему" });
    }
    if (!!docValue.text === "") {
      setDocError({ ...docError, text: "Нельзя отправить пустой документ" });
    }

    if (docError.text || docError.theme_id) {
      setSubmitting(false);

      return;
    }
    !pdd_id
      ? postPdd(docValue).then(({ data, status }) => {
          if (status != 200) {
            store.setAlert(data, "error");
            return;
          }
          store.setAlert(data, "success");
          nav("/pdd");
        })
      : updatePdd(pdd_id, docValue).then(({ data, status }) => {
          if (status != 200) {
            store.setAlert(data, "error");
            return;
          }
          store.setAlert(data, "success");
          nav("/pdd");
        });

    setSubmitting(false);
  };

  const onEditorInputChange = (newValue, editor) => {
    handleChange(newValue, "text");
  };

  return (
    <>
      <div>
        <p style={{ padding: "12px", paddingBottom: 0 }}>
          Добавление раздела ПДД
        </p>
        {!loading && (
          <div
            style={{
              display: "flex",

              justifyContent: "space-between",
              margin: "12px",
            }}>
            <TextField
              error={docError.theme_id}
              helperText={docError.theme_id}
              value={docValue.theme_id}
              label="Тема"
              name={"theme_id"}
              onChange={(e) => {
                const currentValue = e.target.value;
                handleChange(currentValue, e.target.name);
              }}
              select
              size="small"
              sx={{ width: "300px" }}>
              {themeList.map((theme) => {
                return (
                  <MenuItem
                    key={theme.id}
                    value={theme.id}
                    style={{ maxWidth: "300px" }}>
                    {theme.theme_number}.
                    {theme.master_theme_id == null ? "" : theme.theme_subnumber}{" "}
                    {theme.name}
                  </MenuItem>
                );
              })}
            </TextField>
            <Button
              disabled={submitting}
              onClick={handleSubmit}
              variant="contained">
              Отправить
            </Button>
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Editor
            apiKey="f5p74v6l3b162um2le2bq10iq1d6c6vrs7056b1f7jn3f97n"
            init={{
              plugins: [
                // Core editing features
                "anchor",
                "autolink",
                "charmap",
                "codesample",
                "emoticons",
                "image",
                "link",
                "lists",
                "media",
                "searchreplace",
                "table",
                "visualblocks",
                "wordcount",
                // // Your account includes a free trial of TinyMCE premium features
                // // Try the most popular premium features until Jun 27, 2025:
                // "checklist",
                // "mediaembed",
                // "casechange",
                // "formatpainter",
                // "pageembed",
                // "a11ychecker",
                // "tinymcespellchecker",
                // "permanentpen",
                // "powerpaste",
                // "advtable",
                // "advcode",
                // "editimage",
                // "advtemplate",
                // "ai",
                // "mentions",
                // "tinycomments",
                // "tableofcontents",
                // "footnotes",
                // "mergetags",
                // "autocorrect",
                // "typography",
                // "inlinecss",
                // "markdown",
                // "importword",
                // "exportword",
                // "exportpdf",
              ],
              toolbar:
                "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
              // tinycomments_mode: "embedded",
              // tinycomments_author: "Author name",
              // mergetags_list: [
              //   { value: "First.Name", title: "First Name" },
              //   { value: "Email", title: "Email" },
              // ],
            }}
            onEditorChange={(value, editor) => {
              onEditorInputChange(value, editor);
            }}
            initialValue={docValue.text || ""}
          />
          <FolderTree />
        </div>
      </div>
    </>
  );
}
